<template>
  <div>
    <div class="option">
      <div class="title-option-head">ตัวเลือกสินค้า</div>
      <div class="title">ราคาขายปกติ</div>
      <div class="title">ราคาลดเหลืิอ</div>
      <div class="title">ราคาขายต่อครั้ง</div>
      <div class="title"></div>
    </div>
    <div
      v-for="(
        packageOptionPrice, packageOptionPriceIndex
      ) in packageOptionPrices"
      :key="packageOptionPriceIndex"
      :class="{
        'last-service': isLastService(packageOptionPriceIndex)
      }"
      class="table-option"
    >
      <div class="combine-option-head">
        <div v-if="!packageOptionPrice.service_main_option" class="title-header">
          {{ packageOptionPrice.service_title }}
        </div>
        <div v-else class="title-option-head">
          {{ packageOptionPrice.service_title }}
        </div>
        <div v-if="!packageOptionPrice.service_main_option" class="title-price">
          <div>
            <el-input
              :value="packageOptionPrice.service_original_price"
              :disabled="handleReadOnlyPrice(
                readOnlyPrices,
                packageOptionPrice.service_id,
                packageOptionPrice.is_discount,
                packageOptionPrice.is_out_of_stock,
                packageOptionPrice.is_not_sale
              )"
              class="input-price"
              type="number"
              min="0"
              @input="handleChangeInputService(
                $event,
                'service_original_price',
                packageOptionPrice.service_id
              )"
            ></el-input>
          </div>
          <div>
            <el-input
              :value="packageOptionPrice.service_price"
              :disabled="handleReadOnlyPrice(
                readOnlyPrices,
                packageOptionPrice.service_id,
                packageOptionPrice.is_discount,
                packageOptionPrice.is_out_of_stock,
                packageOptionPrice.is_not_sale
              ) || !packageOptionPrice.is_discount"
              class="input-price"
              type="number"
              min="0"
              @input="handleChangeInputService(
                $event,
                'service_price',
                packageOptionPrice.service_id
              )"
            ></el-input>
          </div>
          <div>
            <div
              v-for="(
                serviceAppointmentPrice, serviceAppointmentPriceIndex
              ) in packageOptionPrice.service_appointment_prices"
              :key="serviceAppointmentPriceIndex"
              class="table-detail-price"
            >
              <div
                v-if="packageOptionPrice.is_appointment"
                class="option-price"
              >
                ครั้งที่: {{ serviceAppointmentPrice.appoint_no }}
              </div>
              <div v-else class="option-price">สินค้า</div>
              <div>
                <el-input
                  :value="serviceAppointmentPrice.appoint_price"
                  :disabled="handleReadOnlyPrice(
                    readOnlyPrices,
                    packageOptionPrice.service_id,
                    packageOptionPrice.is_discount,
                    packageOptionPrice.is_out_of_stock,
                    packageOptionPrice.is_not_sale
                  ) || !packageOptionPrice.is_discount"
                  class="input-price"
                  type="number"
                  min="0"
                  @input="handleChangeInputServiceAppointment(
                    $event,
                    'appoint_price',
                    packageOptionPrice.service_id,
                    serviceAppointmentPrice.appoint_no
                  )"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="menu-status">
            <div class="checkbox-option">
              <el-checkbox
                :value="packageOptionPrice.is_out_of_stock"
                :disabled="disabled"
                @input="handleChangeInputService(
                  $event,
                  'is_out_of_stock',
                  packageOptionPrice.service_id
                )"
                >หมดสต๊อก</el-checkbox
              >
            </div>
            <div class="sub-title-price">
              <el-checkbox
                :value="packageOptionPrice.is_discount"
                :disabled="handleReadOnlyDiscount(
                  packageOptionPrice.is_discount,
                  packageOptionPrice.is_not_sale
                )"
                @input="handleChangeInputService(
                  $event,
                  'is_discount',
                  packageOptionPrice.service_id
                )"
                >ลดราคา</el-checkbox
              >
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(
          optionVariant, optionVariantIndex
        ) in packageOptionPrice.service_option_variants"
        :key="optionVariantIndex"
      >
        <div
          v-for="(variant, variantIndex) in optionVariant.variants"
          :key="variantIndex"
        >
          <div 
            :class="{
              'last-item': isLastVariant(
                variantIndex, 
                optionVariant, 
                optionVariantIndex, 
                packageOptionPrice
              )
            }"
            class="combine-option-sub"
          >
            <div class="title-option">
              <div v-if="variantIndex === 0">{{ variant.title }}</div>
              <div v-else>+ {{ variant.title }}</div>
            </div>
            <div class="title-price">
              <div>
                <el-input
                  :value="variant.original_price"
                  :disabled="handleReadOnlyPrice(
                    readOnlyOptionVariantPrice,
                    variant.id,
                    variant.is_discount,
                    variant.is_out_of_stock,
                    variant.is_not_sale
                  )"
                  type="number"
                  min="0"
                  @input="handleChangeInputOption(
                    $event,
                    'original_price',
                    packageOptionPrice.service_id,
                    optionVariant.id,
                    variant.id
                  )"
                ></el-input>
              </div>
              <div>
                <el-input
                  :value="variant.price"
                  :disabled="handleReadOnlyPrice(
                    readOnlyOptionVariantPrice,
                    variant.id,
                    variant.is_discount,
                    variant.is_out_of_stock,
                    variant.is_not_sale
                  ) || !variant.is_discount"
                  type="number"
                  min="0"
                  @input="handleChangeInputOption(
                    $event,
                    'price',
                    packageOptionPrice.service_id,
                    optionVariant.id,
                    variant.id
                  )"
                ></el-input>
              </div>
              <div>
                <div
                  v-for="(
                    appointmentPrice, appointmentPriceIndex
                  ) in variant.appointment_prices"
                  :key="appointmentPriceIndex"
                  class="table-detail-price"
                >
                  <div
                    v-if="packageOptionPrice.is_appointment"
                    class="option-price"
                  >
                    ครั้งที่: {{ appointmentPrice.appoint_no }}
                  </div>
                  <div v-else class="option-price">สินค้า</div>
                  <div>
                    <el-input
                      :value="appointmentPrice.appoint_price"
                      :disabled="handleReadOnlyPrice(
                        readOnlyOptionVariantPrice,
                        variant.id,
                        variant.is_discount,
                        variant.is_out_of_stock,
                        variant.is_not_sale
                      ) || !variant.is_discount"
                      class="input-price"
                      type="number"
                      min="0"
                      @input="handleChangeInputOptionAppointment(
                        $event,
                        'appoint_price',
                        packageOptionPrice.service_id,
                        optionVariant.id,
                        variant.id,
                        appointmentPrice.appoint_no
                      )"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="menu-status-option">
                <div class="status">
                  <div v-if="!variant.is_out_of_stock" class="status-active">
                    มีในสต๊อก
                  </div>
                  <div v-else class="status-not-active">หมดสต๊อก</div>
                </div>
                <div class="status">
                  <div v-if="!variant.is_not_sale" class="status-active">
                    ขาย
                  </div>
                  <div v-else class="status-not-active">ไม่ขาย</div>
                </div>
                <div class="sub-title-price">
                  <el-checkbox
                    :value="variant.is_discount"
                    :disabled="handleReadOnlyDiscount(
                      variant.is_discount,
                      variant.is_not_sale
                    )"
                    @input="handleChangeInputOption(
                      $event,
                      'is_discount',
                      packageOptionPrice.service_id,
                      optionVariant.id,
                      variant.id
                    )"
                    >ลดราคา</el-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Checkbox } from "element-ui";
import { distributePrice } from "@/lib/formatter";

export default {
  components: {
    "el-input": Input,
    "el-checkbox": Checkbox,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    packageOptionPrices: {
      get() {
        return this.value.packageOptions;
      },
    },
    readOnlyPrices() {
      return this.value.newServicePrices;
    },
    readOnlyOptionVariantPrice() {
      return this.value.newOptionVariantPrices;
    }
  },
  methods: {
    handleChangeInputService(event, key, serviceId) {
      for (let si = 0; si < this.value.packageOptions.length; si += 1) {
        const service = this.value.packageOptions[si];
        if (service.service_id === serviceId) {
          switch (key) {
            case "service_price":
              service.service_price = event;

              this.calculateAppointmentPrice(service);
              break;
            case "service_original_price":
              service.service_original_price = event;

              if (!service.is_discount) {
                service.service_price = event;
              }

              this.calculateAppointmentPrice(service);
              break;
            case "is_out_of_stock":
              service.is_out_of_stock = event;
              break;
            case "is_discount":
              service.is_discount = event;

              if (event === false) {
                service.service_price = service.service_original_price;
                this.calculateAppointmentPrice(service);
              }
              break;
            default:
              break;
          }
        }
      }

      this.$emit("input", this.value);
    },
    handleChangeInputServiceAppointment(event, key, serviceId, appointmentNo) {
      for (let si = 0; si < this.value.packageOptions.length; si += 1) {
        const service = this.value.packageOptions[si];
        if (service.service_id === serviceId) {
          for (let ai = 0; ai < service.service_appointment_prices.length; ai += 1) {
            const appointmentPrice = service.service_appointment_prices[ai];
            if (appointmentNo === appointmentPrice.appoint_no) {
              switch (key) {
                case "appoint_price":
                  appointmentPrice.appoint_price = event;
                  break;
                default:
                  break;
              }
            }
          }
        }
      }

      this.$emit("input", this.value);
    },
    handleChangeInputOption(event, key, serviceId, optionVariantId, variantId) {
      for (let si = 0; si < this.value.packageOptions.length; si += 1) {
        const service = this.value.packageOptions[si];
        if (service.service_id === serviceId) {
          for (let oi = 0; oi < service.service_option_variants.length; oi += 1) {
            const option = service.service_option_variants[oi];
            if (option.id === optionVariantId) {
              for (let vi = 0; vi < option.variants.length; vi += 1) {
                const variant = option.variants[vi];
                if (variant.id === variantId) {
                  switch (key) {
                    case "price":
                      variant.price = event;

                      this.calculateAppointmentOptionPrice(variant);
                      break;
                    case "is_out_of_stock":
                      variant.is_out_of_stock = event;
                      break;
                    case "original_price":
                      variant.original_price = event;

                      if (!variant.is_discount) {
                        variant.price = event;
                      }

                      this.calculateAppointmentOptionPrice(variant);
                      break;
                    case "is_discount":
                      variant.is_discount = event;

                      if (event === false) {
                        variant.price = variant.original_price;
                        this.calculateAppointmentOptionPrice(variant);
                      }
                      break;
                    default:
                      break;
                  }
                }
              }
            }
          }
        }
      }

      this.$emit("input", this.value);
    },
    handleChangeInputOptionAppointment(
      event,
      key,
      serviceId,
      optionVariantId,
      variantId,
      apppointmentNo
    ) {
      for (let si = 0; si < this.value.packageOptions.length; si += 1) {
        const service = this.value.packageOptions[si];
        if (service.service_id === serviceId) {
          for (let oi = 0; oi < service.service_option_variants.length; oi += 1) {
            const option = service.service_option_variants[oi];
            if (option.id === optionVariantId) {
              for (let vi = 0; vi < option.variants.length; vi += 1) {
                const variant = option.variants[vi];
                if (variant.id === variantId) {
                  for (let ai = 0; ai < variant.appointment_prices.length; ai += 1) {
                    const appointmentPrice = variant.appointment_prices[ai];
                    if (appointmentPrice.appoint_no === apppointmentNo) {
                      switch (key) {
                        case "appoint_price":
                          appointmentPrice.appoint_price = event;
                          break;
                        default:
                          break;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      this.$emit("input", this.value);
    },
    isLastService(index) {
      return index === this.packageOptionPrices.length - 1;
    },
    isLastVariant(variantIndex, optionVariant, optionVariantIndex, packageOptionPrice) {
      return variantIndex === optionVariant.variants.length - 1
        && optionVariantIndex === packageOptionPrice.service_option_variants.length - 1;
    },
    handleReadOnlyPrice(listIds, id, isDiscount, isOutOfStock, isNotSale) {
      // Outside edit mode the whole form is view-only, whatever the row state.
      if (this.disabled) {
        return true;
      }

      // The create page opens every price field; none of the locks below apply there.
      if (this.value.isReadOnlyOptionPrice) {
        return false;
      }

      // A row that is out of stock or no longer sold keeps its prices locked even when it
      // carries no price yet. An existing ลดราคา flag still opens the fields, so a discount
      // already on the row can be corrected or cleared by hand.
      if ((isOutOfStock || isNotSale) && !isDiscount) {
        return true;
      }

      const newReadOnlyOptionPrice = listIds.length > 0
        ? listIds.find((item) => item === id)
        : undefined;

      return !newReadOnlyOptionPrice && !isDiscount;
    },
    handleReadOnlyDiscount(isDiscount, isNotSale) {
      if (this.disabled) {
        return true;
      }

      // The create page opens every control; the lock below does not apply there.
      if (this.value.isReadOnlyOptionPrice) {
        return false;
      }

      // A row that is no longer sold must not take a new discount. A flag already on such a
      // row stays clickable so it can still be unticked, which then locks the row.
      return isNotSale && !isDiscount;
    },
    calculateAppointmentOptionPrice(variant) {
      distributePrice(variant.appointment_prices, variant.price);
    },
    calculateAppointmentPrice(service) {
      distributePrice(service.service_appointment_prices, service.service_price);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-option {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 12px;
  margin-bottom: 12px;

  &.last-service {
    border-bottom: none;
    margin-bottom: 0;
  }
}

.option {
  background: #f2f2f2;

  display: grid;
  grid-template-columns: 290px 100px 100px 230px 300px;
  gap: 10px;
}

.option > div {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
}

.title-price {
  font-size: 12px;
  font-weight: normal;

  display: grid;
  grid-template-columns: 100px 100px 230px 300px;
  gap: 10px;
}

.title-option {
  padding: 10px;
  font-size: 12px;
  font-weight: normal;
}

.title {
  font-size: 12px;
  font-weight: normal;
  padding: 10px;

  &-option-head {
    padding: 10px;
    font-size: 15px;
    font-weight: bold;
  }

  &-option-main {
    padding: 10px;
    text-decoration: underline;
    font-size: 15px;
    font-weight: bold;
  }

  &-header {
    padding: 10px;
    font-size: 15px;
    font-weight: bold;
  }
}

.combine-option-head {
  padding: 8px 12px;

  display: grid;
  grid-template-columns: 290px 100px 100px 230px 300px;
}

.combine-option-sub {
  padding-left: 12px;

  display: grid;
  grid-template-columns: 290px 100px 100px 230px 300px;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 12px;
  margin-bottom: 12px;
  
  .menu-status-option {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: start;
  }
  
  &.last-item {
    border-bottom: none;
    margin-bottom: 0;
  }
}

.sub-title-price {
  padding-top: 3px;
  display: flex;
  align-items: center;
}

.checkbox-option {
  border: none;
  padding-top: 3px;
  padding-left: 5px;
  display: flex;
  align-items: center;
}

.status {
  padding-left: 10px;
  padding-top: 5px;

  &-active {
    color: rgb(9, 128, 5);
  }

  &-not-active {
    color: rgb(247, 1, 1);
  }
}

.table-detail-price {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-input {
  width: 100px;
  height: auto;
}

.option-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.price-text {
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 14px;
  color: #606266;
}

.input {
  width: max-content;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.menu-status {
  display: grid;
  grid-template-columns: 110px 90px;

  font-size: 12px;
  font-weight: normal;
}

</style>
